module.exports = __webpack_public_path__ + "img/2.f6f8c1d0.png";